import { FC, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Style } from '@capacitor/status-bar';

import { SuccessStep } from '@mopla/constants';
import {
	Footer,
	MainWithFooterTemplate,
	useStatusBarStyleSync,
} from '@mopla/ui';
import { ContentWrapper } from '@mopla/ui/layouts/WelcomeScreen';

import { VerifyFailureScreen } from '../../../../organisms/VerifyFailureScreen/VerifyFailureScreen';
import { useWelcomePageStoreContext } from '../../useWelcomePageStore';
import { TSetInterceptor } from '../../utils/useInterceptor';

export interface IVerifyEmailFailedFlowProps {
	setCloseInterceptor: TSetInterceptor;
	onBottomSliderClose: VoidFunction;
}

export const VerifyEmailFailedFlow: FC<IVerifyEmailFailedFlowProps> = ({
	setCloseInterceptor,
	onBottomSliderClose,
}) => {
	const { setSuccessType, dispatch } = useWelcomePageStoreContext();
	const { push, pop } = useStatusBarStyleSync();
	const navigate = useNavigate();

	useEffect(() => {
		setCloseInterceptor(onBottomSliderClose);

		return () => {
			setCloseInterceptor(null);
		};
	}, [onBottomSliderClose, setCloseInterceptor]);

	useEffect(() => {
		push({
			title: 'ForgotPasswordFlow',
			style: Style.Light,
		});

		return () => {
			pop();
		};
	}, [push, pop]);

	const onResendSuccessHandler = useCallback(() => {
		setSuccessType(SuccessStep.verifyEmail);
		dispatch({ type: 'SET_VERIFY_FAILURE', payload: false });
		navigate({ pathname: '/welcome', search: 'registration' });
	}, [dispatch, navigate, setSuccessType]);

	return (
		<VerifyFailureScreen
			onResendSuccess={onResendSuccessHandler}
			render={({ content, submit }) => (
				<MainWithFooterTemplate
					className="mainWithFooter"
					content={<ContentWrapper>{content}</ContentWrapper>}
					footer={<Footer>{submit}</Footer>}
				/>
			)}
		/>
	);
};
